




























































// Vue
import { Component, Vue } from 'vue-property-decorator'

// Components
import { DataTable } from '../../table'
import { IsActive } from '@/components'

// services
import { PositionService } from '@/services/config'

// Models
import { Paginator } from '@/models'
import { Position } from '@/models/config'

@Component({
    name: 'TableListPositions',
    components: {
        DataTable,
        IsActive
    }
})
export default class TableListPositions extends Vue {
    loading = false
    items: [Position] | [] = []
    pagination: Paginator = {
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    }

    fields = [
        {
            key: 'name',
            sortable: true,
            label: 'Cargo'
        },
        {
            key: 'description',
            sortable: true,
            label: 'Descripción'
        },
        {
            key: 'status_text',
            sortable: true,
            label: 'Status'
        },
        {
            key: 'actions',
            sortable: false,
            label: '',
            thClass: 'one-line w-30',
            thStyle: {
                width: '15%'
            }
        }
    ]

    created () {
        this.getPositionsWithPagination()
    }

    changePage (page: number) {
        this.pagination.currentPage = page
        this.getPositionsWithPagination()
    }

    changePerPage (perPage: number) {
        this.pagination.perPage = perPage
        this.pagination.currentPage = 1
        this.getPositionsWithPagination()
    }

    async getPositionsWithPagination () {
        this.loading = true
        const response = await PositionService.getWithPagination(this.pagination.perPage, this.pagination.currentPage)
        this.items = response.objects
        this.pagination = response.pagination
        this.loading = false
    }
}
